import {
  CARD_DECK_COLORS,
  CARD_DECK_RADIUS,
  CARD_DECK_SHADOWS,
} from './constants';

/**
 * NoActivitiesCard Component
 * 
 * Card-like component shown when fewer than 3 activities are available.
 * Maintains visual consistency with activity cards.
 */
export default function NoActivitiesCard() {
  return (
    <div
      className="flex flex-col items-center justify-center bg-white text-center w-full aspect-[382/462] p-6 sm:p-7 md:p-8 lg:p-10"
      style={{
        borderRadius: `${CARD_DECK_RADIUS.card}px`,
        boxShadow: CARD_DECK_SHADOWS.card,
      }}
    >
      {/* Illustration/Icon */}
      <div
        className="w-20 sm:w-22 md:w-24 lg:w-28 h-20 sm:h-22 md:h-24 lg:h-28 rounded-full flex items-center justify-center mb-6"
        style={{ backgroundColor: 'rgba(1, 167, 200, 0.1)' }}
      >
        <svg
          width="48"
          height="48"
          viewBox="0 0 48 48"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M24 4C12.954 4 4 12.954 4 24s8.954 20 20 20 20-8.954 20-20S35.046 4 24 4zm0 36c-8.822 0-16-7.178-16-16S15.178 8 24 8s16 7.178 16 16-7.178 16-16 16z"
            fill="#01A7C8"
          />
          <path
            d="M24 14c-1.105 0-2 .895-2 2v12c0 1.105.895 2 2 2s2-.895 2-2V16c0-1.105-.895-2-2-2zM24 32c-1.105 0-2 .895-2 2s.895 2 2 2 2-.895 2-2-.895-2-2-2z"
            fill="#01A7C8"
          />
        </svg>
      </div>

      {/* Heading */}
      <h3
        className="font-medium mb-2 text-[18px] sm:text-[19px] md:text-[20px] lg:text-[22px]"
        style={{
          color: CARD_DECK_COLORS.titleText,
          fontFamily: 'DM Sans, sans-serif',
        }}
      >
        No Activities Available
      </h3>

      {/* Message */}
      <p
        className="text-[13px] sm:text-[14px] md:text-[15px] lg:text-[17px] max-w-[240px] sm:max-w-[260px] md:max-w-[280px]"
        style={{
          color: CARD_DECK_COLORS.descriptionText,
          fontFamily: 'DM Sans, sans-serif',
        }}
      >
        We&apos;re working on adding more activities. Please check back soon!
      </p>
    </div>
  );
}
